<script>
    import { loadQuotes } from "lib/load-quotes";

    import { waiting, customExchange, dim } from "stores/toggles";

    import css from "./footer.css";

    function handleFooterClick() {
        customExchange.set(!$customExchange);

        loadQuotes();
    }

    const i18n = window.strings.exchange;

    $: footerType = $customExchange ? "packages" : "custom";
</script>

<div class="{`hbox ${css.footer}`}" data-dim={$dim}>
    <p class="{css.disclaimer}">{@html i18n.footer.info}</p>

    <div class="{css.goto}">
        <p>{i18n.footer[footerType].text}</p>

        <button
            class="{$waiting ? css.disabledFooterBtn : css.footerBtn }"
            on:click={handleFooterClick}
        >
            {i18n.footer[footerType].button}
        </button>
    </div>
</div>